import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
export const ArrowDownIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75468 9.86348L7.86514 7.75453C8.16059 7.4606 8.6389 7.45984 8.93435 7.75529C9.22904 8.04998 9.22904 8.52905 8.93359 8.82374L4.99905 12.756L1.06602 8.82374C0.770574 8.52905 0.770574 8.04998 1.06602 7.75529C1.36147 7.45984 1.83903 7.45984 2.13448 7.75529L4.24343 9.86348L4.24343 1.42164C4.24343 1.00454 4.58195 0.666015 4.99905 0.666015C5.41616 0.666015 5.75468 1.00454 5.75468 1.42164L5.75468 9.86348Z",
    fill: color
  }));
};
export default ArrowDownIcon;